export const enum EvideFormStatusValue {
  Draft = 'Draft',
  Published = 'Published',
}

export const enum DataTypeValues {
  None = 'None',
  String = 'String',
  Integer = 'Integer',
  Double = 'Double',
  DateTime = 'DateTime',
  TimeSpan = 'TimeSpan',
}

export enum InputControllerTypeValues {
  TextBox = 'TextBox',
  TextArea = 'TextArea',
  Numeric = 'Numeric',
  Dropdown = 'Dropdown',
  RadioButtons = 'RadioButtons',
  Checkboxes = 'Checkboxes',
  DatePicker = 'DatePicker',
  TimePicker = 'TimePicker',
  DateTimePicker = 'DateTimePicker',
  Toggle = 'Toggle',
  Checkbox = 'Checkbox',
  DropdownMulti = 'DropdownMulti',
  DropdownWithExtraText = 'DropdownWithExtraText',
  Label = 'Label'
}

export const enum InputTypeValues {
  SystemInput = 'SystemInput',
  Code = 'Code',
  Parameter = 'Parameter',
  SqlColumnName = 'SqlColumnName',
  SqlColumnValue = 'SqlColumnValue'
}

export const enum RuleTypeValues {
  InsertDataQuery = 'InsertDataQuery',
  InputDataSourceQuery = 'InputDataSourceQuery',
  UpdateDataSourceQuery = 'UpdateDataSourceQuery',
  FinishDataQuery = 'FinishDataQuery',
  ErrorDataQuery = 'ErrorDataQuery',
  GetDynamicCombo = 'GetDynamicCombo',
  GetWizardDataSource = 'GetWizardDataSource'
}

export enum NotificationPermission {
  granted = 'granted',
  denied = 'denied',
  ask = '',
}